import { Controller } from "@hotwired/stimulus"

// Onglets de la page bilan carbone. Affiche un panneau à la fois, mémorise
// l'onglet actif dans l'URL (#hash) et mappe les ancres historiques (ex. #lignes,
// venant d'un redirect) vers le bon onglet.
export default class extends Controller {
  static targets = ["tab", "panel"]

  ANCHORS = { lignes: "donnees", imports: "donnees", collectes: "donnees", progression: "avancee" }

  connect() {
    // Priorité au param ?tab= (survit aux redirects serveur, contrairement au
    // #hash que Turbo supprime), puis au #hash (navigation par clic).
    let key = new URLSearchParams(window.location.search).get("tab")
    if (!key) key = (window.location.hash || "").replace("#", "")
    key = this.ANCHORS[key] || key
    if (!this.hasPanel(key)) key = this.tabTargets[0]?.dataset.tab
    this.activate(key)
  }

  show(event) {
    const key = event.currentTarget.dataset.tab
    this.activate(key)
    // On retire le ?tab= (posé par un redirect serveur) pour qu'il ne reprenne
    // pas la main au prochain reload, et on garde l'onglet dans le #hash.
    const url = new URL(window.location)
    url.searchParams.delete("tab")
    url.hash = key
    history.replaceState(null, "", url)
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  hasPanel(key) {
    return this.panelTargets.some((p) => p.dataset.tab === key)
  }

  activate(key) {
    this.tabTargets.forEach((t) => t.classList.toggle("is-active", t.dataset.tab === key))
    this.panelTargets.forEach((p) => p.classList.toggle("is-active", p.dataset.tab === key))
  }
}
